import React, { useState, useEffect, useCallback } from "react"

import { Container, Row, Col } from "react-bootstrap"

import { navigate } from "gatsby"

import Paginator from "../paginator/paginator"

import Warning from "../../images/icons/wdn-warning.png"
import UpArrow from "../../images/icons/wdn-arrow-down.png"

import {
  CANDIDATE_SHORTLIST_BULK,
  CANDIDATE_ADD_TO_CART_BULK,
} from "../company-profile/statistics/action/statisticsAction"
// import { SAVE_SEARCH_RESULTS } from "../../components/shared-actions/searchActions"

import "./search.scss"
import SearchInput from "../input/search-input"
import InputBox from "../input/wdn-input-box"
import ReturnIdIfExists from "../../utils/return-id-if-exists"
import InputRange from "react-input-range"
import debounce from "../../utils/debounce"
import TagList from "./tag-list"
import SavedSearch from "./saved-search"
import ListOfSearch from "./list-of-search"
import Recommendation from "./recommendations"
import SalaryMinMax from "./salary-min-max"
import LocationFilter from "./location-filter"
import StatusFilter from "./status-filter"
import WorkTypeFilter from "./work-type-filter"
import { formatSalaryWithComma } from "../../utils/formatSalary"
import getCountryData from "../../utils/get-country-data"
import { selectValueFromId } from "../../utils/format-skills-for-select"
import TagInput from "../input/tag-input"

const Search = ({
  shortlist,
  cart,
  filterData,
  setFilterData,
  listOfSearch,
  config,
  search,
  state,
  listOfRecommendations,
  processing,
  bulkProcessing,
  setBulkProcessing,
  setProcessing,
  setCP,
  searchLoading,
  cP,
  meta,
  location,
  savedSearch,
  setSavedSearch,
  handleModalHide,
  message,
  setMessage,
  handleSaveModalHide,
}) => {
  const [showExperience, setShowExperience] = useState(true)
  const [showLocation, setShowLocation] = useState(true)
  const [status, setShowStatus] = useState(true)
  const [showWorkType, setShowWorkType] = useState(true)
  const [showExpectedSalary, setShowExpectedSalary] = useState(true)
  const [showSearchHistory, setShowSearchHistory] = useState(true)
  const [provinceList, setProvinceList] = useState([])
  const [cityList, setCityList] = useState([])

  const [experience, setExperience] = useState({
    min: 0,
    max: 5,
  })
  const [statusList, setStatusList] = useState([])
  const [workType, setWorkType] = useState([])
  const [country, setCountry] = useState(
    state.isAuthenticated ? state?.user?.company?.country : 0
  )
  const [minSalaryBar, setMinSalaryBar] = useState(0)
  const [province, setProvince] = useState(0)
  const [city, setCity] = useState(0)
  const [perpage, setPerPage] = useState(0)
  const [bulk, setBulk] = useState(null)
  const [industry, setIndustry] = useState(
    state.isAuthenticated ? state.user?.company?.industry_id : ""
  )
  const [selected, setSelected] = useState([])
  const [text, setText] = useState([])
  const [minSalary, setMinSalary] = useState("")
  const [maxSalary, setMaxSalary] = useState("")
  const [errors, setErrors] = useState("")

  const handleResetClick = () => {
    const country_id = country
    setCountry(
      state.isAuthenticated ? state?.user?.company?.country : country_id
    )
    setMinSalary(country_id?.minSalary)
    setMaxSalary()
    setWorkType([])
    setExperience({ min: 0, max: 5 })
    setCity(0)
    setProvince(0)
    setIndustry(state.isAuthenticated ? state.user?.company?.industry_id : "")
    setStatusList([])
    const max = document.getElementById("maxSalary")
    const min = document.getElementById("minSalary")
    min.value = formatSalaryWithComma(
      country_id?.minSalary
        ? Number(country_id?.minSalary)
        : Number(country?.minSalary)
    )
    max.value = null
    if (state?.isAuthenticated) {
      navigate(
        "/search-candidates?position=" +
          text +
          "&industry=" +
          state.user.company.industry_id +
          "&country=" +
          1 +
          "&minSalary=" +
          10000 +
          "&minExperience=0&maxExperience=" +
          5
      )
    } else {
      const minSal = getMinSalary(country_id)
      // eslint-disable-next-line no-useless-concat
      let url
      url =
        "?country=" +
        country_id.id +
        "&position=" +
        text +
        "&minExperience=0" +
        "&maxExperience=" +
        5 +
        "&minSalary=" +
        minSal
      navigate("/search-candidates" + url)
    }
  }

  const getMinSalary = country => {
    const value = getCountryData(state?.config?.country, country.id)
    return value.minSalary
  }

  const searchTextChange = value => {
    setText(value)
    if (!!value) {
      const url = encodeQueryData({ ...search, position: value })
      navigate("/search-candidates?" + url)
    } else {
      const url = encodeQueryData({ ...search })
      const sr = document.getElementById("search")
      if (sr && search.position) {
        setText(search.position)
        sr.value = search.position
      }
      navigate("/search-candidates?" + url)
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearchTextChange = useCallback(
    debounce(value => {
      return searchTextChange(value)
    }, 1000),
    [searchTextChange]
  )

  const handleTextSearchChange = (value, e) => {
    debouncedSearchTextChange(value, e)
  }

  const handlePageEntriesChange = value => {
    setPerPage(value)
    const url = encodeQueryData({ ...search, perpage: value })
    navigate("/search-candidates?" + url)
  }

  const handleExperienceChange = value => {
    if (experience.min !== 0 || experience.max <= config.experience.length) {
      const url = encodeQueryData({
        ...search,
        maxExperience: experience.max,
        minExperience: experience.min,
      })
      navigate("/search-candidates?" + url)
    } else {
      if (search.minExperience) {
        delete search["minExperience"]
      }
      if (search.maxExperience) {
        delete search["maxExperience"]
      }
      navigate("/search-candidates?" + encodeQueryData(search))
    }
  }

  function encodeQueryData(data) {
    const ret = []
    for (let d in data)
      if (Array.isArray(data[d])) {
        for (let dd in data[d]) {
          ret.push(d + "=" + encodeURIComponent(data[d][dd]))
        }
      } else {
        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]))
      }
    return ret.join("&")
  }

  const handleStatusChange = value => {
    const index = statusList.indexOf(value.toString())
    const newChecked = [...statusList]
    if (index === -1) {
      newChecked.push(value.toString())
    } else {
      newChecked.splice(index, 1)
    }
    setStatusList(newChecked)
    if (newChecked.length > 0) {
      if (search.status) {
        delete search["status"]
      }
      const url = encodeQueryData({ ...search, status: newChecked })
      navigate(`/search-candidates?${url}`)
    } else {
      delete search["status"]
      const url = encodeQueryData({ ...search })
      navigate(`/search-candidates?${url}`)
    }
  }

  const handleBulkChange = value => {
    setBulkProcessing(true)
    const data = {
      company_id: state.user.company.id,
      list: selected,
    }
    setBulk(value)
    if (value === "2") {
      CANDIDATE_ADD_TO_CART_BULK(data, setBulkProcessing, setMessage)
    }
    if (value === "1") {
      CANDIDATE_SHORTLIST_BULK(data, setBulkProcessing, setMessage)
    }
    setBulk(null)
    setSelected([])
  }

  const handleWorkTypeChange = value => {
    const index = workType.indexOf(value.toString())
    const newChecked = [...workType]
    if (index === -1) {
      newChecked.push(value.toString())
    } else {
      newChecked.splice(index, 1)
    }
    setWorkType(newChecked)
    if (newChecked.length > 0) {
      if (search.job_types) {
        delete search["job_types"]
      }
      const url = encodeQueryData({ ...search, job_types: newChecked })
      navigate(`/search-candidates?${url}`)
    } else {
      delete search["job_types"]
      const url = encodeQueryData({ ...search })
      navigate(`/search-candidates?${url}`)
    }
  }

  const handleCountryChange = val => {
    const value = val?.id
    const provinceData = ReturnIdIfExists(config.country, value)
    search.country = value
    setProvinceList(provinceData.province)
    setCountry(provinceData)
    setProvince(0)
    setCity(0)

    if (search.state) {
      delete search["state"]
    }
    if (search.location) {
      delete search["location"]
    }
    delete search["minSalary"]
    delete search["maxSalary"]
    const url = encodeQueryData({
      ...search,
      country: value,
      minSalary: provinceData.minSalary,
    })
    const min = document.getElementById("minSalary")
    const max = document.getElementById("maxSalary")
    min.value = formatSalaryWithComma(Number(provinceData.minSalary))
    max.value = ""
    setMinSalaryBar(provinceData.minSalary)
    setMinSalary(provinceData.minSalary)
    setMaxSalary("")
    navigate(`/search-candidates?${url}`)
  }

  const handleProvinceChange = val => {
    const value = val?.id
    const cityData = ReturnIdIfExists(provinceList, value)
    setCityList(cityData?.districts)
    setProvince(value)
    setCity(0)
    if (search.city) {
      delete search["city"]
    }
    const url = encodeQueryData({ ...search, state: value })
    navigate(`/search-candidates?${url}`)
  }

  const handleCityChange = value => {
    setCity(value?.id)
    const url = encodeQueryData({ ...search, location: value?.id })
    navigate(`/search-candidates?${url}`)
  }

  const handleIndustryChange = value => {
    setIndustry(value?.id)
    const url = encodeQueryData({ ...search, industry: value?.id })
    navigate("/search-candidates?" + url)
  }

  const setList = value => {
    const list = [...selected]
    const index = list.indexOf(value)
    if (index === -1) {
      list.push(value)
    } else {
      list.splice(index, 1)
    }
    setSelected(list)
  }

  useEffect(() => {
    if (config.experience) {
      setExperience({
        min: 0,
        max: Number(config.experience.length) - 1,
      })
    }
    const sr = document.getElementById("search")
    if (sr && search.position) {
      setText(search.position)
      sr.value = search.position
      sr.blur()
    }
    if (search.minExperience) {
      setExperience({ ...experience, min: search.minExperience })
    }
    if (Number(search?.minExperience) > Number(search?.maxExperience)) {
      delete search["maxExperience"]
      delete search["minExperience"]
      navigate("/")
    }
    if (search.maxExperience) {
      if (
        Number(search.maxExperience) >
        Number(config?.experience?.length) - 1
      ) {
        search.minExperience = 0
        search.maxExperience = Number(config?.experience?.length) - 1
      }
      setExperience({
        ...experience,
        max: search.maxExperience,
        min: search.minExperience,
      })
    }

    if (search.job_types) {
      setWorkType(search.job_types)
    }
    if (search.industry) {
      setIndustry(search.industry)
    }
    if (search.status) {
      setStatusList(search.status)
    }
    if (search.perpage) {
      setPerPage(search.perpage)
    }

    if (search.minSalary || minSalaryBar) {
      setShowExpectedSalary(true)
      const min = document.getElementById("minSalary")
      if (min) {
        min.value =
          formatSalaryWithComma(Number(search.minSalary)) ||
          formatSalaryWithComma(Number(minSalaryBar))
      }
      setMinSalary(search.minSalary)
    }
    if (search.maxSalary || minSalaryBar) {
      setShowExpectedSalary(true)
      const max = document.getElementById("maxSalary")
      if (max) {
        max.value = formatSalaryWithComma(Number(search.maxSalary)) || ""
      }
      setMaxSalary(search.maxSalary)
    }
    if (search.country && config.country) {
      const value = ReturnIdIfExists(config.country, search.country)

      if (value && value.province) {
        setProvinceList(value.province)
        setCountry(value)
        setMinSalaryBar(value.minSalary)
      } else {
        delete search["province"]
        delete search["city"]
        search["country"] = 1
      }
      setFilterData({ ...filterData, country: search.country })
    } else {
      if (!search.country) {
        search["country"] = 1
        if (state.isAuthenticated) {
          search["industry"] = state.user.company.industry_id
        }
      }
    }
    if (search.state) {
      const cityData = ReturnIdIfExists(provinceList, search.state)
      if (cityData && cityData.districts) {
        setCityList(cityData.districts)
      } else {
        delete search["location"]
        setCity(0)
      }
      setProvince(search.state)
    }
    if (search.location) {
      setCity(search.location)
    }
  }, [state.cart, state.shortlist]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="search">
      <Container>
        <Row>
          <Col md={3}>
            <Row>
              <Col className="mb-4">
                <SearchInput
                  placeholder="Accountant"
                  onChange={handleTextSearchChange}
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      e.target.blur()
                    }
                  }}
                  onFocus={() => {}}
                  onBlur={e => e.target.blur()}
                />
              </Col>
              <Col lg={12}>
                <TagInput
                  name="industry"
                  styles={` outline-faded`}
                  error={errors?.industry ? `error` : ""}
                  options={state?.config?.industry}
                  value={selectValueFromId(
                    state?.config?.industry,
                    industry?.id ? industry?.id : industry
                  )}
                  placeholder={"Type and Select..."}
                  useOnChange={handleIndustryChange}
                  onFocus={() => {}}
                  closeMenuOnSelect
                  isClearable={false}
                />
                <div className="border-bottom mb-3"></div>
              </Col>
              <Col lg={12} className="mb-2 ">
                <Row className="align-items-center">
                  <Col xs={10} className="mb-2">
                    <h5>Experience</h5>
                  </Col>
                  <Col xs={2} className="text-right mb-2">
                    <button
                      className="no-outline no-border no-background p-0"
                      onClick={() => setShowExperience(!showExperience)}
                    >
                      <img
                        src={UpArrow}
                        alt="wdn-arrow"
                        className={!showExperience ? "up" : "down"}
                      />
                    </button>
                  </Col>
                  {showExperience && (
                    <Col lg={12} className="px-4 mb-4">
                      {config.experience && (
                        <InputRange
                          maxValue={Number(config.experience.length) - 1}
                          minValue={0}
                          formatLabel={value => `${value}yrs`}
                          value={{
                            min: Number(experience.min),
                            max: Number(experience.max),
                          }}
                          onChange={value => {
                            setExperience(value)
                          }}
                          onChangeComplete={value => {
                            handleExperienceChange(value)
                          }}
                        />
                      )}
                    </Col>
                  )}
                  <Col lg="12">
                    <p className="extra-text">
                      Looking for Candidates more than{" "}
                      {config?.experience?.length - 1} years Experience?{" "}
                      <a href="mailto:hi@wdnexus.com ">Contact Us</a>
                    </p>
                  </Col>
                </Row>
                <div className="border-bottom mb-2"></div>
              </Col>
              <LocationFilter
                showLocation={showLocation}
                setCityList={setCityList}
                config={config}
                setShowLocation={setShowLocation}
                UpArrow={UpArrow}
                handleCountryChange={handleCountryChange}
                handleProvinceChange={handleProvinceChange}
                search={search}
                province={province}
                provinceList={provinceList}
                city={city}
                cityList={cityList}
                handleCityChange={handleCityChange}
              />
              <StatusFilter
                search={search}
                config={config}
                status={status}
                setShowStatus={setShowStatus}
                handleStatusChange={handleStatusChange}
                UpArrow={UpArrow}
                statusList={statusList}
              />
              <WorkTypeFilter
                config={config}
                workType={workType}
                UpArrow={UpArrow}
                handleWorkTypeChange={handleWorkTypeChange}
                setShowWorkType={setShowWorkType}
                showWorkType={showWorkType}
              />
              <Col lg={12} className="mb-2">
                <Row className={"align-items-center"}>
                  <Col xs={10}>
                    <h5>Expected Salary</h5>
                  </Col>
                  <Col xs={2} className="text-right">
                    <button
                      className="no-outline no-border no-background"
                      onClick={() => setShowExpectedSalary(!showExpectedSalary)}
                    >
                      <img
                        src={UpArrow}
                        alt="wdn-arrow"
                        className={!showExpectedSalary ? "up" : "down"}
                      />
                    </button>
                  </Col>

                  <SalaryMinMax
                    showExpectedSalary={showExpectedSalary}
                    minSalaryBar={minSalaryBar}
                    minSalary={minSalary}
                    maxSalary={maxSalary}
                    setMinSalary={setMinSalary}
                    setMaxSalary={setMaxSalary}
                    country={country}
                    search={search}
                    errors={errors}
                    setErrors={setErrors}
                    encodeQueryData={encodeQueryData}
                  />
                </Row>
                {savedSearch.length > 0 && (
                  <div className="border-bottom mb-2"></div>
                )}
              </Col>
              {savedSearch.length > 0 && (
                <Col lg={12} className="mb-2">
                  <Row
                    className={
                      showSearchHistory
                        ? "align-items-center mb-4"
                        : "align-items-center"
                    }
                  >
                    <Col xs={10}>
                      <h5>Search History</h5>
                    </Col>
                    <Col xs={2} className="text-right mb-2">
                      <button
                        className="no-outline no-border no-background"
                        onClick={() => setShowSearchHistory(!showSearchHistory)}
                      >
                        <img
                          src={UpArrow}
                          alt="wdn-arrow"
                          className={!showSearchHistory ? "up" : "down"}
                        />
                      </button>
                    </Col>
                    {showSearchHistory && (
                      <Col className="pt-2 pl-3 pr-2">
                        <SavedSearch
                          search={savedSearch}
                          handleModalHide={handleModalHide}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
              )}
            </Row>
          </Col>
          <Col md={9}>
            <div className="ml-0">
              <Row>
                <Col lg="6" className="mb-4">
                  <h3> {meta.count ? meta.count : "0"} Candidate/s Found:</h3>
                </Col>
                <Col lg="6">
                  <Row className="justify-content-end">
                    {selected.length > 0 && (
                      <Col lg="6">
                        <InputBox
                          type="select"
                          optionHeader="Bulk Actions"
                          onChange={handleBulkChange}
                          options={[
                            { id: 1, name: "Add to Shortlist" },
                            { id: 2, name: "Add CV to Cart" },
                          ]}
                          key_value="name"
                          value={bulk}
                          styles="rounded-border faded-outline"
                        />
                      </Col>
                    )}
                    <Col lg="6">
                      <InputBox
                        type="select"
                        optionHeader="Show"
                        onChange={handlePageEntriesChange}
                        options={[
                          { id: 5, name: 5 },
                          { id: 10, name: 10 },
                          { id: 20, name: 20 },
                          { id: 30, name: 30 },
                          { id: 40, name: 40 },
                          { id: 50, name: 50 },
                        ]}
                        key_value="name"
                        value={perpage}
                        styles="rounded-border faded-outline"
                      />
                    </Col>
                  </Row>
                </Col>
                {message && message !== "" && (
                  <Col lg="12">
                    <div className="alert-block mb-4 d-flex align-items-center">
                      <img src={Warning} className="mr-3" alt="wdn-warning" />
                      {message}
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  {Object.keys(config).length > 0 && (
                    <TagList
                      handleModalHide={handleSaveModalHide}
                      savedSearch={savedSearch}
                      setSavedSearch={setSavedSearch}
                      location={location}
                      state={state}
                      setMessage={setMessage}
                      text={text}
                      search={search}
                      config={config}
                      provinceList={provinceList}
                      cityList={cityList}
                      experience={experience}
                      statusList={statusList}
                      workType={workType}
                      country={country}
                      province={province}
                      city={city}
                      industry={industry}
                      handleResetClick={handleResetClick}
                      minSalary={minSalary}
                      maxSalary={maxSalary}
                      minSalaryBar={minSalaryBar}
                    />
                  )}
                </Col>
                {listOfSearch.length > 0 ? (
                  <ListOfSearch
                    searchLoading={searchLoading}
                    setProcessing={setProcessing}
                    bulkProcessing={bulkProcessing}
                    cart={cart}
                    shortlist={shortlist}
                    listOfSearch={listOfSearch}
                    processing={processing}
                    selected={selected}
                    setList={setList}
                  />
                ) : (
                  <Col lg="12" className="text-center">
                    <h3 className="mt-5">No Results Found</h3>
                  </Col>
                )}
                {listOfRecommendations && listOfRecommendations.length > 0 && (
                  <Col lg="9" className="mb-4 mt-4">
                    <h3>Recommended Candidates:</h3>
                  </Col>
                )}
                <Recommendation
                  searchLoading={searchLoading}
                  setProcessing={setProcessing}
                  bulkProcessing={bulkProcessing}
                  cart={cart}
                  shortlist={shortlist}
                  listOfRecommendations={listOfRecommendations}
                  processing={processing}
                  selected={selected}
                  setList={setList}
                />
              </Row>
              {meta && meta.total_pages && meta.total_pages > 1 && (
                <div className="float-right mt-4">
                  <Paginator
                    pageCount={meta.total_pages}
                    pageRangeDisplayed={2}
                    selected={cP}
                    setCurrentPage={setCP}
                    initialPage={cP}
                    marginPagesDisplayed={2}
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Search
